import type { MouseEvent } from 'react';
import MoreVertIcon from '@mui/icons-material/MoreVert';
import { IconButton } from '@mui/material';
import type { SxProps, Theme } from '@mui/material/styles';

export const CARD_MENU_BUTTON_CLASS = 'card-menu-button';

export const cardWithMenuSx: SxProps<Theme> = {
  position: 'relative',
  width: '100%',
  transition: 'none',
  '&:hover': { transform: 'none', boxShadow: 'none' },
  [`& .${CARD_MENU_BUTTON_CLASS}`]: {
    opacity: 0,
    pointerEvents: 'none',
    transition: (theme) => theme.transitions.create('opacity'),
    '@media (hover: none)': { opacity: 1, pointerEvents: 'auto' },
  },
  [`&:hover .${CARD_MENU_BUTTON_CLASS}, &:focus-within .${CARD_MENU_BUTTON_CLASS}`]:
    {
      opacity: 1,
      pointerEvents: 'auto',
    },
};

export interface CardMenuButtonProps {
  onClick: (event: MouseEvent<HTMLElement>) => void;
  variant?: 'default' | 'filled';
}

const CardMenuButton = ({
  onClick,
  variant = 'default',
}: CardMenuButtonProps) => (
  <IconButton
    className={CARD_MENU_BUTTON_CLASS}
    size="small"
    aria-label="Open menu"
    sx={{
      position: 'absolute',
      top: 4,
      right: 4,
      zIndex: 2,
      ...(variant === 'filled'
        ? {
            color: 'primary.contrastText',
            bgcolor: 'primary.main',
            '&:hover': {
              color: 'primary.contrastText',
              bgcolor: 'primary.main',
            },
          }
        : {}),
    }}
    onClick={(event) => {
      event.stopPropagation();
      onClick(event);
    }}
    onMouseDown={(event) => event.stopPropagation()}
  >
    <MoreVertIcon fontSize="small" />
  </IconButton>
);

export default CardMenuButton;
